import { render, staticRenderFns } from "./InventarioResiduos.vue?vue&type=template&id=4421e53f&"
import script from "./InventarioResiduos.vue?vue&type=script&lang=js&"
export * from "./InventarioResiduos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports